import 'uplot/dist/uPlot.min.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/components/spinner.css';
import './styles/components/app-shell.css';
import './styles/components/ship.css';
import './styles/components/columns.css';
import './styles/components/combobox.css';
import './styles/components/derived.css';
import './styles/components/filters.css';
import './styles/components/outliers.css';
import './styles/components/export.css';
import './styles/components/plot.css';
import './styles/components/map.css';
import './styles/components/table.css';
import './styles/components/gauge.css';
import './styles/components/sankey.css';
import './styles/components/spmodel.css';
import './styles/components/sfoc.css';
import './styles/components/assistant.css';
import './styles/components/presets.css';
import './styles/components/dashboard.css';
import './styles/components/catalog.css';
import './styles/components/home.css';
// Last, and referenced by nothing above it: Argus is removable in one delete.
import './styles/components/argus.css';
import './styles/components/live-status.css';
import './styles/components/admin.css';
import './styles/components/ui-gallery.css';
import './styles/components/toast.css';
import './styles/components/confirm.css';
import './styles/components/hold-switch.css';
import './styles/components/live-chip.css';
import './styles/components/locked-nav.css';
import './styles/components/alert-glow.css';
import './styles/components/auth.css';
import './styles/components/preferences.css';
import './styles/components/notifications.css';
import './styles/components/announcements.css';
import './styles/components/tours.css';
import './state/hover-tooltips.ts';
import './app-root.ts';
import { initializeAuth } from './auth/auth.ts';
import { handleStaleChunk } from './state/app-build.ts';
import { installErrorReporting } from './api/error-reporting.ts';

window.addEventListener('vite:preloadError', handleStaleChunk);
// Before anything can fail: errors nothing caught go to the server's log.
installErrorReporting();

void initializeAuth().catch(() => undefined);
